/**
 * @generated SignedSource<<3057dc94fcee68f027207e60fbb938ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiskCleanupForm_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupMedia_data" | "DiskCleanupStorage_data">;
  readonly " $fragmentType": "DiskCleanupForm_data";
};
export type DiskCleanupForm_data$key = {
  readonly " $data"?: DiskCleanupForm_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupForm_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiskCleanupForm_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiskCleanupMedia_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiskCleanupStorage_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "6ac4ea9ff4294c296e22ae7e140159d6";

export default node;
